import ky, { isHTTPError, type Options } from 'ky';

import { errorCodeMap } from './errorCodeMap';

// This client is for data fetching from client

const opts: Options = {
  prefix: `${process.env.NEXT_PUBLIC_AUTH_BASE_API_URL}/`,
  timeout: 15000,
  hooks: {
    beforeError: [
      async ({ error }) => {
        if (!isHTTPError(error)) {
          return error;
        }
        // Log errors in development
        if (process.env.DEBUG) {
          console.error(`Error ${error.response.status} for ${error.request.method} "${error.request.url}"`);
          if (error.data !== undefined) {
            console.error('Received: ', error.data);
          }
        }
        return error;
      },
      async ({ error }) => {
        if (!isHTTPError(error)) {
          return error;
        }
        const body = error.data;
        // Try to use the response body to return the error message from the server
        if (body && typeof body === 'object') {
          if ('message' in body && typeof body.message === 'string' && body.message.length) {
            error.message = body.message;
          }
          if ('code' in body) {
            // Handle error code mapping
            const errorCode = `${body.code}`;
            if (errorCodeMap.has(errorCode)) {
              error.message = errorCodeMap.get(errorCode)!;
            }
          }
          if ('error_message' in body && typeof body.error_message === 'string' && body.error_message.length) {
            error.message = body.error_message;
          }
          if ('error_code' in body) {
            // Handle error code mapping
            const errorCode = `${body.error_code}`;
            if (errorCodeMap.has(errorCode)) {
              error.message = errorCodeMap.get(errorCode)!;
            }
          }
        }
        return error;
      },
    ],
  },
};

/**
 * Note: only to be used in server components
 */
export const carmaCsrClient = ky.create({
  ...opts,
  headers: {
    'Content-Type': 'application/json',
  },
});
